import {
  Order,
  OrderBase,
  OrderTypeConfiguration,
} from "models/order-management/models";
import { StatefulOrderResponse } from "models/order-management/statefullOrderResponse";

export interface OrderTypeSubtype {
  orderType: string;
  orderSubtype: string;
}

export function getOrderTypeDisplayName(
  orderTypeSubtype: OrderTypeSubtype,
  orderTypeConfigurations: OrderTypeConfiguration[]
): string {
  const { orderType, orderSubtype } = orderTypeSubtype;
  const orderTypeConfiguration = orderTypeConfigurations.find(
    (orderTypeConfiguration) => orderTypeConfiguration.orderType === orderType
  );
  if (orderTypeConfiguration) {
    let subtypePart = "";
    if (orderSubtype) {
      subtypePart = ` - ${OrderBase.orderSubtypeDisplay(orderSubtype)}`;
    }
    return `${orderTypeConfiguration.orderTypeDisplayName}${subtypePart}`;
  }
  return "";
}

export function getDiscontinuedProviderDisplayName(
  order: StatefulOrderResponse
): { message: string; isSystemText?: boolean } {
  if (
    order.discontinuedAction?.approvalType == Order.ApprovalTypeEnum.Pending
  ) {
    return { message: "Discontinue Provider Required", isSystemText: true };
  } else if (order.discontinuedAction?.orderingProviderDisplayName) {
    return { message: order.discontinuedAction.orderingProviderDisplayName };
  }
  return { message: "-" };
}



// WEBPACK FOOTER //
// ./src/pages/orders-entry-om/order-utils.ts